export const INLINE = {
  HYPERLINK: "hyperlink",
  ENTRY_HYPERLINK: "entry-hyperlink",
  ASSET_HYPERLINK: "asset-hyperlink",
  RESOURCE_HYPERLINK: "resource-hyperlink",
  EMBEDDED_ENTRY: "embedded-entry-inline",
} as const;

export const BLOCK = {
  DOCUMENT: "document",
  PARAGRAPH: "paragraph",
  TEXT: "text",
  HYPERLINK: "hyperlink",
  ENTRY_HYPERLINK: "entry-hyperlink",

  HEADER_1: "header-1",
  HEADER_2: "header-2",
  HEADER_3: "header-3",
  HEADER_4: "header-4",
  HEADER_5: "header-5",
  HEADER_6: "header-6",

  HEADING_1: "heading-1",
  HEADING_2: "heading-2",
  HEADING_3: "heading-3",
  HEADING_4: "heading-4",
  HEADING_5: "heading-5",
  HEADING_6: "heading-6",

  TABLE: "table",
  TABLE_ROW: "table-row",
  TABLE_HEADER_CELL: "table-header-cell",
  TABLE_CELL: "table-cell",
  TABLE_BODY: "table-body",

  OL_LIST: "ordered-list",
  UL_LIST: "unordered-list",
  LIST_ITEM: "list-item",

  HR: "horizontal-row",
  QUOTE: "blockquote",

  EMBEDDED_ENTRY: "embedded-entity",
  EMBEDDED_ASSET: "embedded-asset-block",

  IMAGE: "image",
  VIDEO: "video",
  RICHTEXTDOCUMENT: "rich-text-document",
  TEASER: "teaser",
} as const;

export const MARK = {
  BOLD: "bold",
  ITALIC: "italic",
  UNDERLINE: "underline",
  CODE: "code",
} as const;

export const ELEMENT = {
  DIV: "div",
  SPAN: "span",
} as const;
